import React, { Component, createRef } from "react";
import Notifications from "../components/commons/Notifications";
const HelloReact = () => {


  const notificationsRef = createRef();


  const showNotification = (title, message, type) => {
    if (notificationsRef.current) {
      notificationsRef.current.addNotifications(title, message, type);
    }
  };

  return (
    <div className="container">
      <Notifications ref={notificationsRef} />
      <h1 className="text-primary">
        <i className="fas fa-check-circle"></i>Hello, Bootstrap and Font Awesome!
      </h1>
      <button
        className="btn btn-success mt-4"
        onClick={() => showNotification("Hola", "Este es un mensaje manual", "success")}
      >
        Mostrar Notificación
      </button>
    </div>
  );
};

export default HelloReact;
